module.exports = __webpack_public_path__ + "static/media/init-actions-create.6ab0849f.png";